module.exports = __webpack_public_path__ + "img/Amex.3daed682.svg";